<template>
  <div>
   <ResalePropertyListComp />
  </div>
</template>

<script>

import ResalePropertyListComp from '../../../../components/tax/delinquent/commissionersSale/CommissionersPropertyList/CommissionersPropertyList.vue';

export default {
  name: 'CommissionersSalePropertyList',
  components: {
    ResalePropertyListComp,
  },
};
</script>
